import { z } from "zod";
import { CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID } from "./entities.js";
export const WEBSITE_DELIVERY_VERTICAL_CONTRACT_SCHEMA_VERSION = "clientops.website-delivery-vertical-contract.v1.0";
export const WebsiteDeliveryRateRuleV1Schema = z
    .object({
    ruleId: z.string().min(1),
    label: z.string().min(1),
    unit: z.enum(["PAGE", "HOUR", "FIXED"]),
    amountCents: z.number().int().nonnegative(),
    currency: z.literal("USD"),
})
    .strict();
export const WebsiteDeliveryCalculationV1Schema = z
    .object({
    calculationId: z.string().min(1),
    expression: z.string().min(1),
    description: z.string().min(1),
})
    .strict();
export const WebsiteDeliveryClauseV1Schema = z
    .object({
    clauseId: z.string().min(1),
    title: z.string().min(1),
    body: z.string().min(1),
    requiresLegalReview: z.boolean(),
})
    .strict();
export const WebsiteDeliveryApprovalRuleV1Schema = z
    .object({
    ruleId: z.string().min(1),
    artifactKind: z.enum(["ESTIMATE", "PROPOSAL", "CONTRACT"]),
    requiredRole: z.enum(["OPERATOR", "AGENCY_OWNER", "CLIENT"]),
    minApprovals: z.number().int().positive(),
})
    .strict();
export const WebsiteDeliveryVerticalContractV1Schema = z
    .object({
    schemaVersion: z.literal(WEBSITE_DELIVERY_VERTICAL_CONTRACT_SCHEMA_VERSION),
    verticalId: z.literal(CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID),
    contractVersion: z.string().regex(/^v\d+\.\d+$/),
    fields: z.array(z.string().min(1)),
    rates: z.array(WebsiteDeliveryRateRuleV1Schema),
    calculations: z.array(WebsiteDeliveryCalculationV1Schema),
    clauses: z.array(WebsiteDeliveryClauseV1Schema),
    approvalRules: z.array(WebsiteDeliveryApprovalRuleV1Schema),
    publishedAt: z.string().datetime(),
})
    .strict();
export const WEBSITE_DELIVERY_VERTICAL_CONTRACT_V1 = WebsiteDeliveryVerticalContractV1Schema.parse({
    schemaVersion: WEBSITE_DELIVERY_VERTICAL_CONTRACT_SCHEMA_VERSION,
    verticalId: CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID,
    contractVersion: "v1.0",
    fields: [
        "scopeSummary",
        "pageCount",
        "revisionRounds",
        "launchTargetDate",
        "hostingResponsibility",
    ],
    rates: [
        {
            ruleId: "rate_page_standard",
            label: "Standard page build",
            unit: "PAGE",
            amountCents: 45000,
            currency: "USD",
        },
        {
            ruleId: "rate_fixed_discovery",
            label: "Discovery workshop",
            unit: "FIXED",
            amountCents: 75000,
            currency: "USD",
        },
    ],
    calculations: [
        {
            calculationId: "calc_page_subtotal",
            expression: "pageCount * rate_page_standard.amountCents",
            description: "Page build subtotal from approved rate card",
        },
    ],
    clauses: [
        {
            clauseId: "clause_scope_change",
            title: "Scope change",
            body: "Material scope changes require a revised estimate and client approval.",
            requiresLegalReview: false,
        },
        {
            clauseId: "clause_ip_transfer",
            title: "IP transfer",
            body: "IP transfers only after final payment and launch checklist completion.",
            requiresLegalReview: true,
        },
    ],
    approvalRules: [
        {
            ruleId: "approve_estimate_client",
            artifactKind: "ESTIMATE",
            requiredRole: "CLIENT",
            minApprovals: 1,
        },
        {
            ruleId: "approve_proposal_client",
            artifactKind: "PROPOSAL",
            requiredRole: "CLIENT",
            minApprovals: 1,
        },
    ],
    publishedAt: "2026-07-25T00:00:00.000Z",
});
export function getWebsiteDeliveryVerticalContract(version) {
    if (version && version !== WEBSITE_DELIVERY_VERTICAL_CONTRACT_V1.contractVersion) {
        throw new Error("unsupported_vertical_contract_version");
    }
    return WEBSITE_DELIVERY_VERTICAL_CONTRACT_V1;
}
//# sourceMappingURL=vertical-contract.js.map